import { Component } from '@angular/core';

@Component({
  templateUrl: 'licenses.page.html',
})
export class LicensesPage {
  items = [{
    name: 'Angular',
    copyright: 'Super-powered by Google ©2010-2021',
    license: 'MIT',
    homepage: 'https://angular.io/'
  }, {
    name: 'Apache Cordova',
    copyright: 'Copyright © 2022 The Apache Software Foundation',
    license: 'Apache-2.0',
    homepage: 'https://cordova.apache.org/'
  }, {
    name: 'Ionic',
    copyright: 'Copyright (c) 2015-present Drifty Co.',
    license: 'MIT',
    homepage: 'https://github.com/driftyco/ionic#readme',
  }, {
    name: 'Ionic Native',
    copyright: 'Copyright (c) 2015-present Drifty Co.',
    license: 'MIT',
    homepage: 'https://github.com/driftyco/ionic-native#readme',
  }, {
    name: 'NGX-Translate',
    copyright: '© NGX-Translate 2016-2017',
    license: 'MIT',
    homepage: 'http://www.ngx-translate.com/'
  }, {
    name: 'RxJS',
    copyright: 'Copyright (c) 2015-2018 Google, Inc., Netflix, Inc., Microsoft Corp. and contributors',
    license: 'Apache-2.0',
    homepage: 'https://github.com/ReactiveX/RxJS#readme'
  }, {
    name: 'cordova-plugin-app-version',
    copyright: 'Copyright (c) 2013 White October',
    license: 'MIT',
    homepage: 'https://github.com/whiteoctober/cordova-plugin-app-version#readme'
  }, {
    name: 'cordova-plugin-ble-central',
    copyright: 'Copyright 2014-2020 Don Coleman',
    license: 'Apache-2.0',
    homepage: 'https://github.com/don/cordova-plugin-ble-central#readme'
  }, {
    name: 'cordova-plugin-device',
    author: 'Apache Software Foundation',
    license: 'Apache-2.0',
    homepage: 'https://github.com/apache/cordova-plugin-device#readme'
  }, {
    name: 'cordova-plugin-fullscreen',
    copyright: 'Copyright (c) 2014, Mesmotronic Limited',
    license: 'BSD',
    homepage: 'https://github.com/mesmotronic/cordova-fullscreen-plugin#readme'
  }, {
    name: 'cordova-plugin-inappbrowser',
    author: 'Apache Software Foundation',
    license: 'Apache-2.0',
    homepage: 'https://github.com/apache/cordova-plugin-inappbrowser#readme'
  }, {
    name: 'cordova-plugin-insomnia',
    author: 'Eddy Verbruggen <eddyverbruggen@gmail.com> (https://github.com/EddyVerbruggen)',
    license: 'MIT',
    homepage: 'https://github.com/EddyVerbruggen/Insomnia-PhoneGap-Plugin#readme'
  }, {
    name: 'cordova-plugin-screen-orientation',
    author: 'Apache Software Foundation',
    license: 'Apache-2.0',
    homepage: 'https://github.com/apache/cordova-plugin-screen-orientation#readme'
  }, {
    name: 'cordova-plugin-splashscreen',
    author: 'Apache Software Foundation',
    license: 'Apache-2.0',
    homepage: 'https://github.com/apache/cordova-plugin-splashscreen#readme'
  }, {
    name: 'cordova-plugin-statusbar',
    author: 'Apache Software Foundation',
    license: 'Apache-2.0',
    homepage: 'https://github.com/apache/cordova-plugin-statusbar#readme'
  }, {
    name: 'cordova-plugin-tts',
    author: 'VILIC VANE',
    license: 'MIT',
    homepage: 'https://github.com/vilic/cordova-plugin-tts#readme'
  }, {
    name: 'cordova-plugin-whitelist',
    author: 'Apache Software Foundation',
    license: 'Apache-2.0',
    homepage: 'https://github.com/apache/cordova-plugin-whitelist#readme'
  }, {
    name: 'cordova-plugin-x-socialsharing',
    author: 'Eddy Verbruggen - @EddyVerbruggen',
    license: 'MIT',
    homepage: 'https://github.com/EddyVerbruggen/SocialSharing-PhoneGap-Plugin#readme'
  }, {
    name: 'cordova-plugin-x-toast',
    author: 'Eddy Verbruggen <eddyverbruggen@gmail.com> (https://github.com/EddyVerbruggen)',
    license: 'MIT',
    homepage: 'https://github.com/EddyVerbruggen/Toast-PhoneGap-Plugin#readme'
  }, {
    name: 'cordova-sqlite-storage',
    author: 'various',
    license: 'MIT',
    homepage: 'https://github.com/litehelpers/Cordova-sqlite-storage'
  }, {
    name: 'cordovarduino',
    copyright: 'Copyright (c) 2015 Xavier Seignard. http://drangies.fr',
    license: 'MIT',
    homepage: 'https://github.com/xseignard/cordovarduino#readme'
  }];
}
